import React from 'react'

import BusinessIcon from "@tecuity/sos-icons/react/business"
import StampIcon from "@tecuity/sos-icons/react/stamp"
import ShieldIcon from "@tecuity/sos-icons/react/shield"
import CapitalIcon from "@tecuity/sos-icons/react/capital"
import CharityIcon from "@tecuity/sos-icons/react/charity"
import ToolsIcon from "@tecuity/sos-icons/react/tools"

const ICONS = {
  business: <BusinessIcon />,
  stamp: <StampIcon />,
  shield: <ShieldIcon />,
  capital: <CapitalIcon />,
  charity: <CharityIcon />,
  tools: <ToolsIcon />
}

export default ICONS



// WEBPACK FOOTER //
// ./src/components/Icons/Icons.js